import { createReducer } from "@reduxjs/toolkit";
const initialState = {
    isLoading: false,
  };

  const servicesReducer = createReducer(initialState, (builder) => {
    builder
      .addCase("get_all_services_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_all_services_success", (state,action) => {
        state.isLoading = false;
        state.Allservices = action.payload.services;
        state.pagination = action.payload.pagination;
        state.totalServices=action.payload.totalServices
      })
      .addCase("get_all_services_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_Fillter_services_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_Fillter_services_success", (state,action) => {
        state.isLoading = false;
        state.FilterServices = action.payload.services;
        state.pagination = action.payload.pagination;
      })
      .addCase("get_Fillter_services_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_services_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_services_success", (state,action) => {
        state.isLoading = false;
        state.servicesData = action.payload;
      })
      .addCase("get_services_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      });
  });
  
  export default servicesReducer;